import React, { useEffect, useState } from 'react';
import * as ListUser from "../../api/ListUser";
import { DataGrid, Popup, ScrollView, Toast } from 'devextreme-react';
import CellRenderIconsGrids from '../../components/Grids/icons-grid/icons-grid';
import CellRenderEstatus from '../../components/Grids/estatus-grid/estatus-grid';
import { Column, ColumnChooser, Export, FilterRow, HeaderFilter, Pager, Paging } from 'devextreme-react/data-grid';
import { ToolbarItem } from 'devextreme-react/popup';
import { Form, GroupItem, SimpleItem, Label } from 'devextreme-react/form';
import './PermissionsAnalytics.scss';



const PermissionsAnalytics = () => {
  const [Users, setUsers] = useState([]);
  const [userData, setUserData] = useState({});
  const [msgPopup, setMsgPopup] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [userPermissions, setUserPermissions] = useState([]);

  const allowedPageSizes = [8, 12, 20];

  const [toastConfig, setToastConfig] = React.useState(
    {
      isVisible: false,
      type: "success",
      message: "Guardado Exitosamente",
      displayTime: 2000,
    },
    []
  );

  const saveButtonOptions = {
    icon: "check",
    text: "Guardar",
    onClick: saveUser,
  };

  const onHiding = () => {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  };

  const editClient = (userid) => {
    ListUser.Get_user_with_permissions(userid.email).then(res => {
      setUserPermissions(res.data.data.permissions)
      setUserData(userid);
      setMsgPopup('Editar permisos del usuario')
      setShowPopup(true);
    });
  };

  function saveUser(e) {
    const transformedPermissions = {
      total_pdv: userPermissions.dashboard.total_pdv || false,
      average_rate_usd: userPermissions.dashboard.average_rate_usd || false,
      total_products: userPermissions.dashboard.total_products || false,
      supervisor_promoter_count: userPermissions.dashboard.supervisor_promoter_count || false,
      category_inventory: userPermissions.dashboard.category_inventory || false,
      top_promoters: userPermissions.dashboard.top_promoters || false,
      top_sku: userPermissions.dashboard.top_sku || false,
      monthly_activations: userPermissions.dashboard.monthly_activations || false,
      weekly_activations: userPermissions.dashboard.weekly_activations || false,
      daily_activations: userPermissions.dashboard.daily_activations || false,
      unreached_sku: userPermissions.dashboard.unreached_sku || false,
      unreached_establishments: userPermissions.dashboard.unreached_establishments || false,
      participation_rate: userPermissions.dashboard.participation_rate || false,
      incidents_count: userPermissions.dashboard.incidents_count || false,
      main_menu: userPermissions.dashboard.main_menu || false,
      participation_comparison: userPermissions.dashboard.participation_comparison || false,
      dashboard_participacion: userPermissions.dashboard.dashboard_participacion || false,
      usage_dashboard: userPermissions.dashboard.usage_dashboard || false,
      unreached_establishments_grid: userPermissions.grid_main.unreached_establishments_grid || false,
      unreached_sku_grid: userPermissions.inventory.unreached_sku_grid || false,
      low_traffic_sku: userPermissions.inventory.low_traffic_sku || false,
      movement_inventory: userPermissions.inventory.movement_inventory || false,
      units_sold: userPermissions.inventory.units_sold || false,
      audit_results: userPermissions.grid_main.audit_results || false,
      photo_records: userPermissions.grid_main.photo_records || false,
      known_brands: userPermissions.survey_dashboard.known_brands || false,
      other_brands: userPermissions.survey_dashboard.other_brands || false,
      total_mentions: userPermissions.survey_dashboard.total_mentions || false,
      preferred_brand: userPermissions.survey_dashboard.preferred_brand || false,
      preference_reason: userPermissions.survey_dashboard.preference_reason || false,
      always_available_brand: userPermissions.survey_dashboard.always_available_brand || false,
      common_behavior: userPermissions.survey_dashboard.common_behavior || false,
      purchase_frequency: userPermissions.survey_dashboard.purchase_frequency || false,
      last_purchase_date: userPermissions.survey_dashboard.last_purchase_date || false,
      surveys_menu: userPermissions.survey_dashboard.surveys_menu || false,
      
      category_inventory_permission: userPermissions.inventory.category_inventory_permission || false,
      establishment_inventory: userPermissions.inventory.establishment_inventory || false,
      
      rate_value: userPermissions.prices.rate_value || false,
      users_template_detail: userPermissions.operations.users_template_detail || false,
      synchronizations: userPermissions.operations.synchronizations || false,
      activation_count: userPermissions.operations.activation_count || false,
      operation_incidents: userPermissions.operations.operation_incidents || false,
      check_in_check_out: userPermissions.operations.check_in_check_out || false,
      perfect_synchronizations: userPermissions.operations.perfect_synchronizations || false,
      grid_reports: userPermissions.operations.grid_reports || false,
      establishments_visited: userPermissions.operations.establishments_visited || false,
      routes_grid: userPermissions.operations.routes_grid || false,
      inventory_category_ia: userPermissions.ia.inventory_category_ia || false,
      participation_analysis_ia: userPermissions.ia.participation_analysis_ia || false,
      planogram_analysis_ia: userPermissions.ia.planogram_analysis_ia || false,
      schedule_analysis_ia: userPermissions.ia.schedule_analysis_ia || false,
      price_analysis_ia: userPermissions.ia.price_analysis_ia || false,
      prompt_management_ia: userPermissions.ia.prompt_management_ia || false,
      promoters_dashboard: userPermissions.operations.promoters_dashboard || false,
      inventory_comparision: userPermissions.inventory.inventory_comparision || false,
      grid_facade_edit: userPermissions.inventory.grid_facade_edit || false,
      participation_analysis: userPermissions.inventory.participation_analysis || false,
      audit_results_regional: userPermissions.grid_main.audit_results_regional || false,

      contest_execution: userPermissions.operations.contest_execution || false,

      // Operaciones
      date_expiration: userPermissions.inventory.date_expiration || false,

      // Precios
      price_detail: userPermissions.prices.price_detail || false,
      price_comparison: userPermissions.prices.price_comparison || false,
      grid_price_edit: userPermissions.prices.grid_price_edit || false,
      grid_detalle_pop: userPermissions.prices.grid_detalle_pop || false,
      comparative_matrix: userPermissions.prices.comparative_matrix || false,
    
      price_verification: userPermissions.prices.price_verification || false,
      price_analysis: userPermissions.prices.price_analysis || false,

      // Tienda Perfecta
      dashboard_store_perfect: userPermissions.store_perfect?.dashboard_store_perfect || false,
      dashboard_promoting: userPermissions.store_perfect?.dashboard_promoting || false,
      list_store_perfect: userPermissions.store_perfect?.list_store_perfect || false,
      
      // Reportes
      grid_reports_new: userPermissions.reports.grid_reports_new || false,
      vacancies_grid: userPermissions.reports.vacancies_grid || false,


      // Métricas
      panel_principal: userPermissions.metrics.panel_principal || false,

      // Auditorias
      audit_results_barcode: userPermissions.grid_main.audit_results_barcode || false,

    };

    const transformedData = {
      userId: userData.id_pg,
      permissions: transformedPermissions,
    };

    ListUser.Update_user_with_permissions(transformedData).then((res) => {
      if (res.data.status === "success") {
        setToastConfig({
          ...toastConfig,
          type: 'success',
          message: 'Guardado Exitosamente',
          isVisible: true,
        });
        hidePopup();
      }
    }).catch((err) => {
      setToastConfig({
        ...toastConfig,
        type: 'error',
        message: err.message,
        isVisible: true,
      });
    });
  }

  const hidePopup = () => {
    setUserPermissions([]);
    setUserData({});
    setShowPopup(false);
    setMsgPopup("");
  };

  const getAllUser = () => {
    ListUser.getDataUserPermission().then((data) => {
      if (data.status === 200) {
        setUsers(data.data);
      }
    }).catch((err) => {
      setToastConfig({
        ...toastConfig,
        type: 'error',
        message: err.message,
        isVisible: true,
      });
    })
  };

  useEffect(() => {
    getAllUser()
  }, []);

  const handleFormChange = (e) => {
    const { dataField, value } = e;
    const fields = dataField.split('.');
    const updatedPermissions = { ...userPermissions };

    let currentField = updatedPermissions;
    for (let i = 0; i < fields.length - 1; i++) {
      currentField = currentField[fields[i]];
    }
    currentField[fields[fields.length - 1]] = value;

    setUserPermissions(updatedPermissions);
  };

  return (
    <React.Fragment>
      <div className="d-flex mt-2">
        <div className="header-grid-title">
          <h5 className="content-block titleCliente">Permisos de Usuarios Analytics</h5>
        </div>
      </div>

      <div className="tabla-Cliente">
        <DataGrid
          className="tabla-Cliente"
          dataSource={Users}
          showBorders={true}
          remoteOperations={true}
          focusedRowEnabled={true}
          defaultFocusedRowIndex={0}
          style={{ height: "430px", width: "100%" }}
          keyExpr="key"
          wordWrapEnabled={true}
        >
          <Export enabled={true} />
          <ColumnChooser
            enabled={true}
            mode="select"
          />
          <FilterRow visible={true} />
          <Paging defaultPageSize={12} />
          <Pager
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
          />
          <HeaderFilter visible={true} />

          <Column
            width={100}
            caption="Cédula"
            dataField="cedula"
            dataType="string"
            sortOrder="asc"
          />

          <Column
            width={120}
            caption="Nombre"
            dataField="nombre"
            dataType="string"
          />

          <Column
            width={120}
            caption="Apellido"
            dataField="apellido"
            dataType="string"
          />

          <Column
            caption="Tipo de Usuario"
            dataField="tipo_usuario"
            dataType="string"
          />

          <Column
            width={340}
            caption="Cliente"
            dataField="cliente"
            dataType="string"
          />

          <Column
            width={140}
            caption="Region"
            dataField="region"
            dataType="string"
          />

          <Column
            width={90}
            caption="Estatus"
            dataField="activado"
            dataType="string"

            cellRender={CellRenderEstatus}
          />

          <Column
            width={80}
            caption=""
            allowSorting={false}
            cellRender={(data) => CellRenderIconsGrids(data, editClient)}
          />
        </DataGrid>
      </div>

      <Popup
        width={"100%"}
        height={"100%"}
        visible={showPopup}
        onHiding={hidePopup}
        showTitle={true}
        title={msgPopup}
        showCloseButton={true}
        fullScreen={true}
      >
        <ToolbarItem
          widget="dxButton"
          toolbar="top"
          location="after"
          options={saveButtonOptions}
        />
        <ScrollView className='editPermissions' width="100%" height="100%">
          <Form
            formData={userPermissions}
            onFieldDataChanged={handleFormChange}
            colCount={3}
            labelLocation="top"
            style={{ marginTop: "2rem" }}
          >
            <GroupItem caption="Dashboard" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="dashboard.total_pdv" editorType="dxCheckBox">
                <Label text="Total PDV" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.average_rate_usd" editorType="dxCheckBox">
                <Label text="Tasa Promedio USD" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.total_products" editorType="dxCheckBox">
                <Label text="Total Productos" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.supervisor_promoter_count" editorType="dxCheckBox">
                <Label text="Conteo Supervisor Promotor" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.category_inventory" editorType="dxCheckBox">
                <Label text="Inventario por Categoría" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.top_promoters" editorType="dxCheckBox">
                <Label text="Mejores Promotores" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.top_sku" editorType="dxCheckBox">
                <Label text="Mejores SKU" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.monthly_activations" editorType="dxCheckBox">
                <Label text="Activaciones Mensuales" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.weekly_activations" editorType="dxCheckBox">
                <Label text="Activaciones Semanales" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.daily_activations" editorType="dxCheckBox">
                <Label text="Activaciones Diarias" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.unreached_sku" editorType="dxCheckBox">
                <Label text="SKU No Alcanzados" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.unreached_establishments" editorType="dxCheckBox">
                <Label text="Establecimientos No Alcanzados" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.participation_rate" editorType="dxCheckBox">
                <Label text="Tasa de Participación" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.incidents_count" editorType="dxCheckBox">
                <Label text="Conteo de Incidentes" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.main_menu" editorType="dxCheckBox">
                <Label text="Menú Principal" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.participation_comparison" editorType="dxCheckBox">
                <Label text="Comparación Participación" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.dashboard_participacion" editorType="dxCheckBox">
                <Label text="Dashboard de Participación" />
              </SimpleItem>
              <SimpleItem dataField="dashboard.usage_dashboard" editorType="dxCheckBox">
                <Label text="Dashboard de Uso" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Grid Principal" colCount={3} >
              <SimpleItem dataField="grid_main.unreached_establishments_grid" editorType="dxCheckBox">
                <Label text="Grid de Establecimientos No Alcanzados" />
              </SimpleItem>
              <SimpleItem dataField="grid_main.audit_results" editorType="dxCheckBox">
                <Label text="Resultados de Auditoría" />
              </SimpleItem>
              <SimpleItem dataField="grid_main.photo_records" editorType="dxCheckBox">
                <Label text="Registros Fotográficos" />
              </SimpleItem>
              <SimpleItem dataField="grid_main.audit_results_regional" editorType="dxCheckBox">
                <Label text="Grid de Resultados de Auditoría Regional" />
              </SimpleItem>
              <SimpleItem dataField="grid_main.audit_results_barcode" editorType="dxCheckBox">
                <Label text="Auditoría de Código de Barras" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Dashboard de Encuestas" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="survey_dashboard.known_brands" editorType="dxCheckBox">
                <Label text="Marcas Conocidas" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.other_brands" editorType="dxCheckBox">
                <Label text="Otras Marcas" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.total_mentions" editorType="dxCheckBox">
                <Label text="Total de Menciones" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.preferred_brand" editorType="dxCheckBox">
                <Label text="Marca Preferida" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.preference_reason" editorType="dxCheckBox">
                <Label text="Razón de Preferencia" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.always_available_brand" editorType="dxCheckBox">
                <Label text="Marca Siempre Disponible" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.common_behavior" editorType="dxCheckBox">
                <Label text="Comportamiento Común" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.purchase_frequency" editorType="dxCheckBox">
                <Label text="Frecuencia de Compra" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.last_purchase_date" editorType="dxCheckBox">
                <Label text="Fecha de Última Compra" />
              </SimpleItem>
              <SimpleItem dataField="survey_dashboard.surveys_menu" editorType="dxCheckBox">
                <Label text="Menú de Encuestas" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Inventario" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="inventory.category_inventory_permission" editorType="dxCheckBox">
                <Label text="Permiso de Inventario por Categoría" />
              </SimpleItem>
              <SimpleItem dataField="inventory.establishment_inventory" editorType="dxCheckBox">
                <Label text="Inventario de Establecimientos" />
              </SimpleItem>
              <SimpleItem dataField="inventory.inventory_comparision" editorType="dxCheckBox">
                <Label text="Anaquel vs Almacén" />
              </SimpleItem>
              <SimpleItem dataField="inventory.grid_facade_edit" editorType="dxCheckBox">
                <Label text="Editar Caras" />
              </SimpleItem>
              <SimpleItem dataField="inventory.participation_analysis" editorType="dxCheckBox">
                <Label text="Análisis de Participación" />
              </SimpleItem>
              <SimpleItem dataField="inventory.date_expiration" editorType="dxCheckBox">
                <Label text="Fecha de Vencimiento" />
              </SimpleItem>
              <SimpleItem dataField="inventory.unreached_sku_grid" editorType="dxCheckBox">
                <Label text="Grid de SKU No Alcanzados" />
              </SimpleItem>
              <SimpleItem dataField="inventory.low_traffic_sku" editorType="dxCheckBox">
                <Label text="SKU Menos Trafico" />
              </SimpleItem>
              <SimpleItem dataField="inventory.movement_inventory" editorType="dxCheckBox">
                <Label text="Movimiento de Inventario" />
              </SimpleItem>
              <SimpleItem dataField="inventory.units_sold" editorType="dxCheckBox">
                <Label text="Unidades Vendidas" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Precios" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="prices.price_detail" editorType="dxCheckBox">
                <Label text="Detalle de Precios" />
              </SimpleItem>
              <SimpleItem dataField="prices.rate_value" editorType="dxCheckBox">
                <Label text="Valor de la Tasa" />
              </SimpleItem>
              <SimpleItem dataField="prices.grid_price_edit" editorType="dxCheckBox">
                <Label text="Editar Precios" />
              </SimpleItem>
              <SimpleItem dataField="prices.grid_detalle_pop" editorType="dxCheckBox">
                <Label text="Detalle Pop" />
              </SimpleItem>
              <SimpleItem dataField="prices.comparative_matrix" editorType="dxCheckBox">
                <Label text="Matriz Comparativa" />
              </SimpleItem>
              <SimpleItem dataField="prices.price_verification" editorType="dxCheckBox">
                <Label text="Verificación de Precios" />
              </SimpleItem>
              <SimpleItem dataField="prices.price_analysis" editorType="dxCheckBox">
                <Label text="Análisis de Precios" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Operaciones" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="operations.users_template_detail" editorType="dxCheckBox">
                <Label text="Detalle de Plantilla de Usuarios" />
              </SimpleItem>
              <SimpleItem dataField="operations.synchronizations" editorType="dxCheckBox">
                <Label text="Sincronizaciones" />
              </SimpleItem>
              <SimpleItem dataField="operations.activation_count" editorType="dxCheckBox">
                <Label text="Conteo de Activaciones" />
              </SimpleItem>
              <SimpleItem dataField="operations.operation_incidents" editorType="dxCheckBox">
                <Label text="Incidentes de Operación" />
              </SimpleItem>
              <SimpleItem dataField="operations.check_in_check_out" editorType="dxCheckBox">
                <Label text="Check In, Check Out" />
              </SimpleItem>
              <SimpleItem dataField="operations.perfect_synchronizations" editorType="dxCheckBox">
                <Label text="Sincronizaciones Perfectas" />
              </SimpleItem>
              <SimpleItem dataField="operations.grid_reports" editorType="dxCheckBox">
                <Label text="Reportes" />
              </SimpleItem>
              <SimpleItem dataField="operations.establishments_visited" editorType="dxCheckBox">
                <Label text="Establecimientos Visitados" />
              </SimpleItem>
              <SimpleItem dataField="operations.routes_grid" editorType="dxCheckBox">
                <Label text="Rutas Activas" />
              </SimpleItem>
              <SimpleItem dataField="operations.promoters_dashboard" editorType="dxCheckBox">
                <Label text="Dashboard de Promotores" />
              </SimpleItem>
              <SimpleItem dataField="operations.contest_execution" editorType="dxCheckBox">
                <Label text="Concurso Ejecución" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Inteligencia Artificial" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="ia.inventory_category_ia" editorType="dxCheckBox">
                <Label text="IA - Categoría de Inventario" />
              </SimpleItem>
              <SimpleItem dataField="ia.participation_analysis_ia" editorType="dxCheckBox">
                <Label text="IA - Análisis de Participación" />
              </SimpleItem>
              <SimpleItem dataField="ia.planogram_analysis_ia" editorType="dxCheckBox">
                <Label text="IA - Análisis de Planograma" />
              </SimpleItem>
              <SimpleItem dataField="ia.schedule_analysis_ia" editorType="dxCheckBox">
                <Label text="IA - Análisis de Horarios" />
              </SimpleItem>
              <SimpleItem dataField="ia.price_analysis_ia" editorType="dxCheckBox">
                <Label text="IA - Análisis de Precios" />
              </SimpleItem>
              <SimpleItem dataField="ia.prompt_management_ia" editorType="dxCheckBox">
                <Label text="IA - Gestión de Prompts" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Tienda Perfecta" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="store_perfect.dashboard_store_perfect" editorType="dxCheckBox">
                <Label text="Dashboard de Tienda Perfecta" />
              </SimpleItem>
              <SimpleItem dataField="store_perfect.dashboard_promoting" editorType="dxCheckBox">
                <Label text="Dashboard de Promoting" />
              </SimpleItem>
              <SimpleItem dataField="store_perfect.list_store_perfect" editorType="dxCheckBox">
                <Label text="Lista de Tienda Perfecta" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Reportes" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="reports.grid_reports_new" editorType="dxCheckBox">
                <Label text="Reportes" />
              </SimpleItem>
              <SimpleItem dataField="reports.vacancies_grid" editorType="dxCheckBox">
                <Label text="Grid de Vacantes" />
              </SimpleItem>
            </GroupItem>
            <GroupItem caption="Métricas" colCount={3} cssClass="form-group full-width">
              <SimpleItem dataField="metrics.panel_principal" editorType="dxCheckBox">
                <Label text="Panel Principal" />
              </SimpleItem>
            </GroupItem>
          </Form>
        </ScrollView>
      </Popup>

      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        onHiding={onHiding}
        displayTime={toastConfig.displayTime}
      />
    </React.Fragment>
  )
}

export default PermissionsAnalytics